var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPartiallyWrongReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#FFF2E2",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1225_59642",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1225_59642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 29.5C26.2833 29.5 26.5208 29.4042 26.7125 29.2125C26.9042 29.0208 27 28.7833 27 28.5C27 28.2167 26.9042 27.9792 26.7125 27.7875C26.5208 27.5958 26.2833 27.5 26 27.5C25.7167 27.5 25.4792 27.5958 25.2875 27.7875C25.0958 27.9792 25 28.2167 25 28.5C25 28.7833 25.0958 29.0208 25.2875 29.2125C25.4792 29.4042 25.7167 29.5 26 29.5ZM25 25.5H27V19.5H25V25.5ZM16 36.5V18.5C16 17.95 16.1958 17.4792 16.5875 17.0875C16.9792 16.6958 17.45 16.5 18 16.5H34C34.55 16.5 35.0208 16.6958 35.4125 17.0875C35.8042 17.4792 36 17.95 36 18.5V30.5C36 31.05 35.8042 31.5208 35.4125 31.9125C35.0208 32.3042 34.55 32.5 34 32.5H20L16 36.5ZM19.15 30.5H34V18.5H18V31.625L19.15 30.5Z",
    fill: "#CC8925"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPartiallyWrongReport);
export default __webpack_public_path__ + "static/media/icon_partially_wrong_report.ad04b065e237b1c9e5ae9ddbf9595459.svg";
export { ForwardRef as ReactComponent };